import { useQuery } from '@tanstack/react-query'
import { FileText, HardDrive } from 'lucide-react'
import { fetchApi, OrzForgeApiError } from '../lib/api'
import type { StorageResponse } from '../types'

export function StoragePage() {
  const query = useQuery<StorageResponse>({
    queryKey: ['storage'],
    queryFn: async () => (await fetchApi('/v1/storage/buckets')) as StorageResponse,
    staleTime: 60_000,
  })

  if (query.isLoading) {
    return (
      <div className="flex h-96 items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-500 border-t-transparent" />
      </div>
    )
  }

  if (query.error) {
    return (
      <div className="rounded-xl border border-red-500/20 bg-red-500/10 p-6 text-red-300">
        Error cargando storage:{' '}
        {query.error instanceof OrzForgeApiError ? query.error.message : 'Error desconocido'}
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-bold">OrzStorage</h1>
        <p className="text-sm text-gray-400">Bucket: {query.data?.bucket}</p>
      </header>

      <div className="rounded-xl border border-white/10 bg-panel">
        {query.data?.files.length ? (
          <ul className="divide-y divide-white/5">
            {query.data.files.map((file) => (
              <li
                key={file}
                className="flex items-center gap-3 px-5 py-3 hover:bg-white/[0.02]"
              >
                <FileText className="h-4 w-4 text-brand-400" />
                <span className="font-mono text-sm text-gray-200">{file}</span>
              </li>
            ))}
          </ul>
        ) : (
          <div className="flex flex-col items-center justify-center gap-3 p-12 text-center">
            <HardDrive className="h-10 w-10 text-gray-600" />
            <p className="text-gray-400">No hay archivos en este bucket aún.</p>
          </div>
        )}
      </div>
    </div>
  )
}
